"use client";

import { cn } from "@/lib/utils";

export const ActionLoader = () => {
  return <span class="custom-action-loader"></span>;
};

export const CustomLoader = () => {
  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>;
};

export default function CircleLoader({ loading, size, className }) {
  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-[1000] bg-brand-100/40 flex items-center justify-center data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0">
      <div
        className={cn(
          "animate-spin rounded-full border-4 border-muted border-t-primary",
          className
        )}
        style={{ width: size, height: size }}
      />
    </div>
  );
}
